import { api } from '../client';

export const attestation = {
  list: api.listAttestations,
};
